import api from '../api';

const path = '/offer';

export const addOfferRequest = (values) => api.post(`${path}/add`, values);
